import React, { createContext, useContext, useState } from "react";

const GoogleReviewsContext = createContext();

export const GoogleReviewsProvider = ({ children }) => {
  const [panelState, setPanelState] = useState({
    isOpen: false,
    hotelName: null,
    city: null,
    address: null,
  });

  const openPanel = (hotelName, city, address) => {
    setPanelState({
      isOpen: true,
      hotelName,
      city,
      address,
    });
  };

  const closePanel = () => {
    setPanelState({
      isOpen: false,
      hotelName: null,
      city: null,
      address: null,
    });
  };

  return (
    <GoogleReviewsContext.Provider
      value={{
        ...panelState,
        openPanel,
        closePanel,
      }}
    >
      {children}
    </GoogleReviewsContext.Provider>
  );
};

export const useGoogleReviews = () => {
  const context = useContext(GoogleReviewsContext);
  if (!context) {
    throw new Error("useGoogleReviews must be used within GoogleReviewsProvider");
  }
  return context;
};

